export default __webpack_public_path__ + "static/media/yourCompany-userName-yyyy-mm-dd-version.5d573e91.xlsx";